var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('offer-search',[_vm._t("heroOverflowContent")],2),_vm._v(" "),_c('offer-list',{attrs:{"offers":_vm.isFiltered ? _vm.filteredOffers : _vm.totalOffers,"is-filtered":_vm.isFiltered}},[(_vm.isFiltered ? !_vm.filteredOffers.length : !_vm.totalOffers.length)?_vm._t("noResult"):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }